/* A necessary level of precision to keep in Geo-coordinates, which comes from planting zone requirements.
   For lat/long, 5 digits is about 3 feet of real-world precision, and 6 digits is < 1 foot. (Varies by location on
   ellipsoid/Earth) */
export const REQUIRED_COORDINATE_PRECISION = 6;

// Related to GeoJson standard (RFC 7946)
export const POLYGON_ARRAY_DEPTH = 3, MULTIPOLYGON_ARRAY_DEPTH = 4;
export const MINIMUM_RING_VERTEX_COUNT = 4; // Minimum # of vertexes in a valid ring.
export const MINIMUM_RING_COUNT = 1;

export const clippingLibrary = {
  TURF: 'Turf',
  MARTINEZ: 'Martinez Polygon Clipping',
  CLIPPERLIB: 'ClipperLib',
  MFOGEL: 'MFOGEL'
};

export const DEFAULT_CLIPPING_LIBRARY = [clippingLibrary.MFOGEL];
